export const NavigationLinks = (app) => {
    return {
        convert: {
            text: app.$t("convert"),
            tools: [
                {
                    icon: "VideoIcon",
                    title: app.$t("video") + " & " + app.$t("audio"),
                    items: [
                        {
                            icon: "VideoIcon",
                            text: app.$t("converter_video_converter"),
                            link: "/video-converter",
                        },
                        {
                            icon: "MusicIcon",
                            text: app.$t("converter_audio_converter"),
                            link: "/audio-converter",
                        },
                        {
                            icon: "MusicIcon",
                            text: "MP3 " + app.$t("converter"),
                            link: "/mp3-converter",
                        },
                        {
                            icon: "MusicIcon",
                            text: "MP4 " + app.$t("to") + " MP3",
                            link: "/mp4-to-mp3",
                        },
                        {
                            icon: "",
                            text: "Video " + app.$t("to") + " MP3",
                            link: "/convert/video-to-mp3",
                        },
                        {
                            icon: "MusicIcon",
                            text: "MP4 " + app.$t("converter"),
                            link: "/mp4-converter",
                        },
                        {
                            icon: "MusicIcon",
                            text: "MOV " + app.$t("to") + " MP4",
                            link: "/mov-to-mp4",
                        },
                        {
                            icon: "",
                            text: "MP3 " + app.$t("to") + " OGG",
                            link: "/mp3-to-ogg",
                        },
                    ],
                },
                {
                    icon: "ImageIcon",
                    title: app.$t("Image"),
                    items: [
                        {
                            icon: "ImageIcon",
                            text: app.$t("converter_image_converter"),
                            link: "/image-converter",
                        },
                        {
                            icon: "",
                            text: "WEBP " + app.$t("to") + " PNG",
                            link: "/webp-to-png",
                        },
                        {
                            icon: "",
                            text: "JFIF " + app.$t("to") + " PNG",
                            link: "/jfif-to-png",
                        },
                        {
                            icon: "",
                            text: "PNG " + app.$t("to") + " SVG",
                            link: "/png-to-svg",
                        },
                        {
                            icon: "",
                            text: "HEIC " + app.$t("to") + " JPG",
                            link: "/heic-to-jpg",
                        },
                        {
                            icon: "",
                            text: "HEIC " + app.$t("to") + " PNG",
                            link: "/heic-to-png",
                        },
                        {
                            icon: "",
                            text: "WEBP " + app.$t("to") + " JPG",
                            link: "/webp-to-jpg",
                        },
                        {
                            icon: "",
                            text: "SVG " + app.$t("converter"),
                            link: "/svg-converter",
                        },
                    ],
                },
                {
                    icon: "FileTextIcon",
                    title: "PDF" + " & " + app.$t("documents"),
                    items: [
                        {
                            icon: "",
                            text: "PDF " + app.$t("converter"),
                            link: "/pdf-converter",
                        },
                        {
                            icon: "",
                            text: `${app.$t("document")} ${app.$t("converter")}`,
                            link: "/document-converter",
                        },
                        {
                            icon: "TabletIcon",
                            text: app.$t("converter_ebook_converter"),
                            link: "/ebook-converter",
                        },
                        {
                            icon: "",
                            text: "PDF " + app.$t("to") + " Word",
                            link: "/pdf-to-word",
                        },
                        {
                            icon: "",
                            text: "PDF " + app.$t("to") + " JPG",
                            link: "/pdf-to-jpg",
                        },
                        {
                            icon: "",
                            text: "PDF " + app.$t("to") + " EPUB",
                            link: "/pdf-to-epub",
                        },
                        {
                            icon: "",
                            text: "EPUB " + app.$t("to") + " PDF",
                            link: "/epub-to-pdf",
                        },
                        {
                            icon: "",
                            text: "HEIC " + app.$t("to") + " PDF",
                            link: "/heic-to-pdf",
                        },
                        {
                            icon: "",
                            text: "DOCX " + app.$t("to") + " PDF",
                            link: "/docx-to-pdf",
                        },
                        {
                            icon: "",
                            text: "JPG " + app.$t("to") + " PDF",
                            link: "/jpg-to-pdf",
                        },
                    ],
                },
                {
                    icon: "GIFIcon",
                    title: "GIF",
                    items: [
                        {
                            icon: "",
                            text: `${app.$t("video")} ${app.$t("to")} GIF`,
                            link: "/convert/video-to-gif",
                        },
                        {
                            icon: "",
                            text: "MP4 " + app.$t("to") + " GIF",
                            link: "/convert/mp4-to-gif",
                        },
                        {
                            icon: "",
                            text: "WEBM " + app.$t("to") + " GIF",
                            link: "/convert/webm-to-gif",
                        },
                        {
                            icon: "",
                            text: "APNG " + app.$t("to") + " GIF",
                            link: "/convert/apng-to-gif",
                        },
                        {
                            icon: "",
                            text: "GIF " + app.$t("to") + " MP4",
                            link: "/convert/gif-to-mp4",
                        },
                        {
                            icon: "",
                            text: "GIF " + app.$t("to") + " APNG",
                            link: "/convert/gif-to-apng",
                        },
                        {
                            icon: "",
                            text: `${app.$t("Image")} ${app.$t("to")} GIF`,
                            link: "/image-to-gif",
                        },
                    ],
                },
                {
                    icon: "OthersIcon",
                    title: app.$t("others"),
                    items: [
                        {
                            icon: "PercentIcon",
                            text: app.$t("converter_unit_converter"),
                            link: "/unit-converter",
                        },
                        {
                            icon: "",
                            text: app.$t("time_converter"),
                            link: "/time/cst-to-est",
                        },
                        {
                            icon: "LayersIcon",
                            text: app.$t("converter_archive_converter"),
                            link: "/archive-converter",
                        },
                    ],
                },
            ],
        },
        compress: {
            text: app.$t("compress"),
            tools: [
                {
                    icon: "VideoIcon",
                    title: app.$t("video") + " & " + app.$t("audio"),
                    items: [
                        {
                            icon: "",
                            text: app.$t("tool_video_compressor"),
                            link: "/video-compressor",
                        },
                        {
                            icon: "",
                            text: "MP3 " + app.$t("compressor"),
                            link: "/mp3-compressor",
                        },
                        {
                            icon: "",
                            text: "WAV " + app.$t("compressor"),
                            link: "/wav-compressor",
                        },
                    ],
                },
                {
                    icon: "ImageIcon",
                    title: app.$t("Image"),
                    items: [
                        {
                            icon: "",
                            text: app.$t("tool_image_compressor"),
                            link: "/image-compressor",
                        },
                        {
                            icon: "",
                            text: app.$t("tool_compress_jpeg"),
                            link: "/compress-jpeg",
                        },
                        {
                            icon: "",
                            text: app.$t("tool_compress_png"),
                            link: "/compress-png",
                        },
                    ],
                },
                {
                    icon: "FileTextIcon",
                    title: "PDF" + " & " + app.$t("documents"),
                    items: [
                        {
                            icon: "",
                            text: app.$t("tool_compress_pdf"),
                            link: "/compress-pdf",
                        },
                    ],
                },
                {
                    icon: "GIFIcon",
                    title: "GIF",
                    items: [
                        {
                            icon: "",
                            text: "GIF " + app.$t("compressor"),
                            link: "/gif-compressor",
                        },
                    ],
                },
            ],
        },
        tools: {
            text: app.$t("navigation_link_item_tools"),
            tools: [
                {
                    icon: "VideoIcon",
                    title: app.$t("video") + " " + app.$t("navigation_link_item_tools"),
                    items: [
                        { icon: "", text: app.$t("tool_crop_video"), link: "/crop-video" },
                        {
                            icon: "",
                            text: app.$t("tool_video_trimmer"),
                            link: "/video-trimmer",
                        },
                    ],
                },
                {
                    icon: "ImageIcon",
                    title: app.$t("Image") + " " + app.$t("navigation_link_item_tools"),
                    items: [
                        {
                            icon: "",
                            text: app.$t("gif_maker"),
                            link: "/gif-maker",
                        },
                        {
                            icon: "",
                            text: app.$t("resize_image"),
                            link: "https://imageresizer.com/",
                            external: true,
                        },
                        {
                            icon: "",
                            text: app.$t("crop_image"),
                            link: "https://imageresizer.com/crop-image",
                            external: true,
                        },
                        {
                            icon: "",
                            text: app.$t("color_picker"),
                            link: "https://imageresizer.com/color-picker",
                            external: true,
                        },
                        {
                            icon: "",
                            text: app.$t("rotate_image"),
                            link: "https://imageresizer.com/rotate-image",
                            external: true,
                        },
                        {
                            icon: "",
                            text: app.$t("flip_image"),
                            link: "https://imageresizer.com/flip-image",
                            external: true,
                        },
                        {
                            icon: "",
                            text: app.$t("image_enlarger"),
                            link: "https://imageresizer.com/image-enlarger",
                            external: true,
                        },
                    ],
                },
                {
                    icon: "FileTextIcon",
                    title: "PDF" + " " + app.$t("navigation_link_item_tools"),
                    items: [
                        {
                            icon: "VideoIcon",
                            text: "PDF " + app.$t("merge"),
                            link: "/merge-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: "PDF " + app.$t("split"),
                            link: "/split-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("flatten")} PDF`,
                            link: "/flatten-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("resize")} PDF`,
                            link: "/resize-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("unlock")} PDF`,
                            link: "/unlock-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("rotate")} PDF`,
                            link: "/rotate-pdf",
                        },
                        {
                            icon: "FileTextIcon",
                            text: `${app.$t("protect")} PDF`,
                            link: "/password-protect-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("extract_image_from_pdf")}`,
                            link: "/extract-images-from-pdf",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("pdf_page_remover")}`,
                            link: "/pdf-page-remover",
                        },
                        {
                            icon: "VideoIcon",
                            text: `${app.$t("extract_pages_from_pdf")}`,
                            link: "/extract-pages-from-pdf",
                        }
                    ],
                },
            ],
        },
        pricing: { text: app.$t("navigation_link_item_pricing"), link: "/pricing" },
        api: {
            text: "API",
            tools: [
                {
                    icon: "FileTextIcon",
                    title: app.$t("documentation"),
                    items: [
                        {
                            icon: "",
                            text: "API Job Builder",
                            link: "/api/job-builder",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "API " + app.$t("documentation"),
                            link: "/api/v1/",
                            external: true,
                        },
                    ],
                },
                {
                    icon: "RepeatIcon",
                    title: app.$t("conversion") + " APIs",
                    items: [
                        {
                            icon: "",
                            text: `File ${app.$t("conversion")} API`,
                            link: "/api/file-conversion-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `Image ${app.$t("conversion")} API`,
                            link: "/api/image-conversion-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `Audio ${app.$t("conversion")} API`,
                            link: "/api/audio-conversion-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `Document ${app.$t("conversion")} API`,
                            link: "/api/document-conversion-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `PDF ${app.$t("conversion")} API`,
                            link: "/api/pdf-conversion-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `MP4 ${app.$t("conversion")} API`,
                            link: "/api/mp4-conversion-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `Video ${app.$t("conversion")} API`,
                            link: "/api/video-conversion-api",
                            external: true,
                        },
                    ],
                },
                {
                    icon: "ApiIcon",
                    title: app.$t("specific") + " APIs",
                    items: [
                        {
                            icon: "",
                            text: "JPG " + app.$t("to") + " PDF API",
                            link: "/api/jpg-to-pdf-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "Video " + app.$t("to") + " MP3 API",
                            link: "/api/video-to-mp3-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "HEIC " + app.$t("to") + " JPG API",
                            link: "/api/heic-to-jpg-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "PDF " + app.$t("to") + " JPG API",
                            link: "/api/pdf-to-jpg-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "Webp " + app.$t("to") + " PNG API",
                            link: "/api/webp-to-png-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "PDF " + app.$t("to") + " WORD API",
                            link: "/api/pdf-to-word-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "MP4 " + app.$t("to") + " MP3 API",
                            link: "/api/mp4-to-mp3-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "Webp " + app.$t("to") + " JPG API",
                            link: "/api/webp-to-jpg-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "WORD " + app.$t("to") + " PDF API",
                            link: "/api/word-to-pdf-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: "HTML " + app.$t("to") + " PDF API",
                            link: "/api/html-to-pdf-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text:
                                "Website " +
                                capitalizeFirstLetter(app.$t("screenshot")) +
                                " API",
                            link: "/api/website-screenshot-api",
                            external: true,
                        },
                    ],
                },
                {
                    icon: "CompressionApiIcon",
                    title: app.$t("compression") + " APIs",
                    items: [
                        {
                            icon: "",
                            text: `Video ${app.$t("compression")} API`,
                            link: "/api/video-compression-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `${app.$t("compress")} PDF API`,
                            link: "/api/compress-pdf-api",
                            external: true,
                        },
                        {
                            icon: "",
                            text: `Image ${app.$t("compression")} API`,
                            link: "/api/image-compression-api",
                            external: true,
                        },
                    ],
                },
            ],
        },
    };
};

export const NavigationAuth = (app) => {
    return {
        userLinks: {
            text: "",
            options: [
                {
                    icon: "",
                    text: app.$t("navigation_link_item_dashboard"),
                    link: "/account/billing-plan",
                },
                { icon: "", text: app.$t("auth_logout"), link: "" },
            ],
        },
    };
};

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
